import { render, staticRenderFns } from "./allotListHistory.vue?vue&type=template&id=aeea4582&scoped=true"
import script from "./allotListHistory.vue?vue&type=script&lang=js"
export * from "./allotListHistory.vue?vue&type=script&lang=js"
import style0 from "./allotListHistory.vue?vue&type=style&index=0&id=aeea4582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeea4582",
  null
  
)

export default component.exports